import { schema } from 'normalizr';
import labelSchema from './label';

const collectionCategorySchema = new schema.Entity('collectionCategories', {
  targets: [labelSchema],
});

export default collectionCategorySchema;
